import { defineMessages } from 'react-intl'

export default defineMessages({
  notifications: {
    id: 'containers.UserSettingsPage.components.Notifications.notifications',
    defaultMessage: 'Notifications',
  },
  manageNotifications: {
    id: 'containers.UserSettingsPage.components.Notifications.manageNotifications',
    defaultMessage: 'Manage which notifications you want to receive.',
  },
  useSetting: {
    id: 'containers.UserSettingsPage.components.Notifications.useSetting',
    defaultMessage: 'Use setting',
  },
  manage: {
    id: 'containers.UserSettingsPage.components.Notifications.manage',
    defaultMessage: 'Manage',
  },
  manageHowNotified: {
    id: 'containers.UserSettingsPage.components.Notifications.manageHowNotified',
    defaultMessage: 'Manage how you will be notified.',
  },
  email: {
    id: 'containers.UserSettingsPage.components.Notifications.email',
    defaultMessage: 'E-mail',
  },
  sentToEmail: {
    id: 'containers.UserSettingsPage.components.Notifications.sentToEmail',
    defaultMessage: 'Sent to your profile e-mail address.',
  },
  pushNotifications: {
    id: 'containers.UserSettingsPage.components.Notifications.pushNotifications',
    defaultMessage: 'Push notifications',
  },
  smsNotifications: {
    id: 'containers.UserSettingsPage.components.Notifications.smsNotifications',
    defaultMessage: 'SMS notifications',
  },
  ifEnabledInBrowser: {
    id: 'containers.UserSettingsPage.components.Notifications.ifEnabledInBrowser',
    defaultMessage: 'If enabled and allowed in browser.',
  },
})
